module.exports = __webpack_public_path__ + "static/media/E7.294835bc.mp3";